import type { FileUploadState } from "~/lib/file-upload/useFileUpload";

/**
 * Maps client upload queue state + optional hydrated asset to a backend-style lifecycle string
 * for labels and icons (aligned with `assetLifecycleUserStatusI18nKey`).
 */
export function resolveClientUploadLifecycleState(
  upload: FileUploadState,
  getAsset: (assetId: string) => { status?: { state?: string } } | undefined
): string {
  if (upload.status === "completed") return "READY";
  if (upload.status === "error") return "FAILED";
  if (upload.status === "pending" || upload.status === "uploading") return "AWAITING_UPLOAD";
  if (upload.status === "processing" && upload.assetId) {
    const st = getAsset(upload.assetId)?.status?.state;
    if (st) return st;
  }
  return "PROCESSING";
}
